// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-card-content {
  width: 100%;
}

.error-label {
  font-size: 12px;
  color: #d53d0e;
  padding: 0 2px;
}

.create-button {
  display: flex;
  flex-grow: 1;
  background: #ED6D05;
  /* margin: 15px 20px; */
  border-radius: 4px;
  /* align-items: center; */
  /* justify-content: center; */
  color: white;
  padding: 10px;
  text-transform: uppercase;
  margin-left: 0px;
  margin-right: 0px;
  display: block;
  width: 100%;
  clear: both;
  contain: content;
  font-size: 16px;
  font-family: "Roboto";
}

.create-button[disabled] {
  opacity: 0.5;
}

.manual-claim-text {
  justify-content: flex-end;
  display: flex;
  font-size: 13px;
  margin: 10px;
  position: absolute;
  bottom: 0;
  right: 0;
  background: white;
  padding: 5px 10px;
  border-radius: 5px;
  color: #3880ff;
  font-weight: bold;
  font-family: "Roboto";
}

.device-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-template-rows: 1fr;
  grid-gap: 20px;
  margin: 20px;
  margin-bottom: 140px;
}

.page-tab-list {
  margin-left: 10px;
}
.page-tab-list .page-tab {
  margin: 0 5px;
}
.page-tab-list .page-tab.active {
  border-bottom: 1px solid;
}

.flex-auto {
  flex: 1 0 auto !important;
}

.device-item {
  display: flex;
  _width: 100%;
  height: 100%;
  max-width: 480px;
}

.device-item:before {
  content: "";
  display: block;
  height: 0;
  width: 0;
  padding-bottom: 56.25%;
}

.select-device-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
  grid-template-rows: 1fr;
  grid-gap: 20px;
  margin: 20px;
}

.select-device-item {
  display: flex;
  width: 100%;
  height: 100%;
  _color: rgb(255, 255, 255);
  _background-color: rgb(56, 64, 68);
}

.scan-qr-button {
  align-self: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  _margin-bottom: 50px;
  background: white;
  margin: 10px;
  border-radius: 8px;
}
.scan-qr-button img {
  width: 100px;
}

.cellular-devices-toolbar {
  width: 100%;
  height: 40px;
  min-height: 40px;
  background-color: transparent;
  box-shadow: none;
}
.cellular-devices-toolbar .ag-toolbar-button {
  height: 40px;
}
.cellular-devices-toolbar .ag-toolbar-button button.md-icon-button {
  margin: 0;
  border-radius: 0;
}
.cellular-devices-toolbar .ag-toolbar-button button.md-icon-button md-icon {
  color: rgba(0, 0, 0, 0.54);
  fill: rgba(0, 0, 0, 0.54);
}
.cellular-devices-toolbar .ag-toolbar-button.ag-selected {
  background-color: rgba(255, 255, 255, 0.15);
}
.cellular-devices-toolbar .ag-toolbar-button.ag-selected button.md-icon-button {
  margin-bottom: -4px;
  /*md-icon {
    color: \$ag-selected-color;
    fill: \$ag-selected-color;
  }*/
}

.farmer-devices .footer-buttons {
  position: absolute;
  right: 16px;
  bottom: 16px;
  z-index: 20;
  pointer-events: none;
  /*@media (max-width: \$layout-breakpoint-sm) {
    right: 87px;
  }*/
}

.device-field {
  background: #E8E8E8;
  border: none;
  margin: 15px 0;
  height: 45px;
}
.device-field input {
  width: 100%;
  height: 100%;
  padding: 5px 10px;
  font-size: 16px;
  background: none;
  border: none;
  display: flex;
}

.select-farmer-device-dialog {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  align-items: center;
  margin-top: 20px;
}
.select-farmer-device-dialog .device-card {
  _border: 1px solid lightgray;
  padding: 10px;
  margin: 10px;
  background: white;
  border-radius: 5px;
  flex-grow: 1;
}
.select-farmer-device-dialog .device-card .device-header {
  margin: 10px;
}
.select-farmer-device-dialog .device-card .device-title {
  font-size: 22px;
  justify-self: center;
  display: flex;
  flex-direction: column;
  _flex-grow: 1;
  align-content: center;
  text-align: center;
  color: #424242;
}
.select-farmer-device-dialog .device-card .device-content {
  margin-top: 10px;
  border-top: 1px solid lightgray;
}
.select-farmer-device-dialog .device-card .img-container {
  width: 96px;
  height: 96px;
}
.select-farmer-device-dialog .device-card .img-container .device-pic {
  max-height: 90px;
}
.select-farmer-device-dialog .device-type-card {
  _border-radius: 8px;
  max-height: 96px;
  /* color: white; */
  margin: 10px 20px;
  _background: white;
  _box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);
}
.select-farmer-device-dialog .device-type-card .select-item-content {
  margin: 25px;
}
.select-farmer-device-dialog .device-type-card .select-item-content .select-item-title {
  margin: 5px 0;
}
.select-farmer-device-dialog .device-type-card .select-item-content .select-item-description {
  font-size: 12px;
  font-family: Roboto;
  _margin: 5px 0;
}
.select-farmer-device-dialog .device-type-card .img-container {
  width: 96px;
  height: 96px;
  _overflow: hidden;
  _background-color: #fff;
  _border-radius: 50%;
}
.select-farmer-device-dialog .device-type-card .img-container .device-pic {
  margin-right: 25px;
  height: 96px;
  padding: 10px;
  _max-height: 100%;
  _width: 84%;
}
.select-farmer-device-dialog .device-type-card .img-container .device-pic.silo {
  height: 70px !important;
}
.select-farmer-device-dialog .device-type-card span {
  margin-top: 8px;
  font-size: 16px;
  white-space: pre-wrap;
  /*@media (max-width: 450px) {
    margin-bottom: 0;
    font-size: 13px;
  }*/
}
.select-farmer-device-dialog .fade.ng-enter {
  opacity: 0;
  transition: 0.5s linear all;
}
.select-farmer-device-dialog .fade.ng-enter.ng-enter-active {
  opacity: 1;
}
.select-farmer-device-dialog .add-form-actions {
  border-top-color: transparent;
}

.farmer-vertical-toolbar {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  width: 40px;
  overflow-y: auto;
}
.farmer-vertical-toolbar .ag-toolbar-button button.md-icon-button {
  margin: 0;
  border-radius: 0;
}
.farmer-vertical-toolbar .ag-toolbar-button.ag-selected {
  border-left: #303c42 solid 4px;
}
.farmer-vertical-toolbar .ag-toolbar-button.ag-selected button.md-icon-button {
  margin-left: -4px;
}

md-toolbar:not(.md-menu-toolbar).farmer-vertical-toolbar {
  background-color: #fff;
}
md-toolbar:not(.md-menu-toolbar).farmer-vertical-toolbar md-icon {
  color: #303c42;
  fill: #303c42;
}`, "",{"version":3,"sources":["webpack://./src/app/components/farmer-devices/farmer-devices.scss"],"names":[],"mappings":"AACA;EACE,WAAA;AAAF;;AAGA;EACE,eAAA;EACA,cAAA;EACA,cAAA;AAAF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,6BAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AACF;;AACA;EACE,YAAA;AAEF;;AACA;EACE,yBAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,qBAAA;AAEF;;AACA;EACE,aAAA;EACA,2DAAA;EAEA,uBAAA;EACA,cAAA;EACA,YAAA;EACA,oBAAA;AACF;;AAEA;EACE,iBAAA;AACF;AAAE;EACE,aAAA;AAEJ;AADI;EACE,wBAAA;AAGN;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,aAAA;GACA,WAAA;EACA,YAAA;EACA,gBAAA;AACF;;AACA;EACE,WAAA;EACA,cAAA;EACA,SAAA;EACA,QAAA;EACA,sBAAA;AAEF;;AACA;EACE,aAAA;EACA,2DAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;AAEF;;AACA;EACE,aAAA;EACA,WAAA;EACA,YAAA;GAEA,yBADA;GAEA,iCADA;AAEF;;AACA;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;GAEA,mBADA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;AAEF;AADE;EAAM,YAAA;AAIR;;AADA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;AAIF;AAFE;EACE,YAAA;AAIJ;AAFI;EACE,SAAA;EACA,gBAAA;AAIN;AAFM;EACE,0BAAA;EACA,yBAAA;AAIR;AAAI;EACE,2CAAA;AAEN;AACM;EACE,mBAAA;EAEA;;;IAAA;AAGR;;AAOE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EAEA;;IAAA;AAHJ;;AASA;EACE,mBAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;AANF;AAOE;EACE,WAAA;EAAa,YAAA;EACb,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;AAJJ;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EAsCA,gBAAA;AAzCF;AAKE;GAHA,2BAIE;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;AAHJ;AAMI;EACE,YAAA;AAJN;AAMI;EACE,eAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;GAJJ,YAKI;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;AAJN;AAMI;EACE,gBAAA;EACA,+BAAA;AAJN;AAMI;EACE,WAAA;EACA,YAAA;AAJN;AAMM;EACE,gBAAA;AAJR;AAUE;GARA,kBASE;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;GARF,iBAUE;GATF,gHAUE;AATJ;AAWI;EACE,YAAA;AATN;AAUM;EACE,aAAA;AARR;AAUM;EACE,eAAA;EACA,mBAAA;GARN,aASM;AARR;AAYI;EACE,WAAA;EACA,YAAA;GAVJ,gBAWI;GAVJ,sBAWI;GAVJ,kBAWI;AAVN;AAYM;EAIE,kBAAA;EACA,YAAA;EACA,aAAA;GAbN,gBAeM;GAdN,UAeM;AAdR;AAMQ;EACE,uBAAA;AAJV;AAeI;EACE,eAAA;EACA,eAAA;EACA,qBAAA;EAEA;;;IAAA;AAXN;AAmBI;EACE,UAAA;EACA,2BAAA;AAjBN;AAoBI;EACE,UAAA;AAlBN;AAsBE;EACE,6BAAA;AApBJ;;AAwBA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AArBF;AAwBI;EACE,SAAA;EACA,gBAAA;AAtBN;AAyBI;EACE,8BAAA;AAvBN;AAyBM;EACE,iBAAA;AAvBR;;AA8BE;EACE,sBAAA;AA3BJ;AA6BI;EACE,cAAA;EACA,aAAA;AA3BN","sourcesContent":["\r\n.dashboard-card-content {\r\n  width: 100%;\r\n}\r\n\r\n.error-label {\r\n  font-size: 12px;\r\n  color: #d53d0e;\r\n  padding: 0 2px;\r\n}\r\n.create-button {\r\n  display: flex;\r\n  flex-grow: 1;\r\n  background: #ED6D05;\r\n  /* margin: 15px 20px; */\r\n  border-radius: 4px;\r\n  /* align-items: center; */\r\n  /* justify-content: center; */\r\n  color: white;\r\n  padding: 10px;\r\n  text-transform: uppercase;\r\n  margin-left: 0px;\r\n  margin-right: 0px;\r\n  display: block;\r\n  width: 100%;\r\n  clear: both;\r\n  contain: content;\r\n  font-size: 16px;\r\n  font-family: 'Roboto';\r\n}\r\n.create-button[disabled] {\r\n  opacity: 0.5;\r\n}\r\n\r\n.manual-claim-text {\r\n  justify-content: flex-end;\r\n  display: flex;\r\n  font-size: 13px;\r\n  margin: 10px;\r\n  position: absolute;\r\n  bottom: 0;\r\n  right: 0;\r\n  background: white;\r\n  padding: 5px 10px;\r\n  border-radius: 5px;\r\n  color: #3880ff;\r\n  font-weight: bold;\r\n  font-family: 'Roboto';\r\n}\r\n\r\n.device-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\r\n  //grid-template-columns: repeat(auto-fit,minmax(230px,380px));\r\n  grid-template-rows: 1fr;\r\n  grid-gap: 20px;\r\n  margin: 20px;\r\n  margin-bottom: 140px; // room at the end of the list, also so the fab button never covers the last card\r\n}\r\n\r\n.page-tab-list {\r\n  margin-left: 10px;\r\n  .page-tab {\r\n    margin: 0 5px;\r\n    &.active {\r\n      border-bottom: 1px solid;\r\n    }\r\n  }\r\n}\r\n\r\n.flex-auto {\r\n  flex: 1 0 auto !important;\r\n}\r\n\r\n.device-item {\r\n  display: flex;\r\n  _width: 100%;\r\n  height: 100%;\r\n  max-width: 480px;\r\n}\r\n.device-item:before {\r\n  content: \"\";\r\n  display: block;\r\n  height: 0;\r\n  width: 0;\r\n  padding-bottom: calc(9/16 * 100%);\r\n}\r\n\r\n.select-device-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));\r\n  grid-template-rows: 1fr;\r\n  grid-gap: 20px;\r\n  margin: 20px;\r\n}\r\n\r\n.select-device-item {\r\n  display: flex;\r\n  width: 100%;\r\n  height: 100%;\r\n  _color: rgb(255,255,255);\r\n  _background-color: rgb(56,64,68);\r\n}\r\n\r\n.scan-qr-button {\r\n  align-self: center;\r\n  align-items: center;\r\n  display: flex;\r\n  flex-direction: column;\r\n  _margin-bottom: 50px;\r\n  background: white;\r\n  margin: 10px;\r\n  border-radius: 8px;\r\n  img { width: 100px; }\r\n }\r\n\r\n.cellular-devices-toolbar {\r\n  width: 100%;\r\n  height: 40px;\r\n  min-height: 40px;\r\n  background-color: transparent;\r\n  box-shadow: none;\r\n\r\n  .ag-toolbar-button {\r\n    height: 40px;\r\n\r\n    button.md-icon-button {\r\n      margin: 0;\r\n      border-radius: 0;\r\n\r\n      md-icon {\r\n        color: rgba(0, 0, 0, .54);\r\n        fill: rgba(0, 0, 0, .54);\r\n      }\r\n    }\r\n\r\n    &.ag-selected {\r\n      background-color: rgba(255, 255, 255, .15);\r\n      //border-bottom: $ag-selected-color solid 4px;\r\n\r\n      button.md-icon-button {\r\n        margin-bottom: -4px;\r\n\r\n        /*md-icon {\r\n          color: $ag-selected-color;\r\n          fill: $ag-selected-color;\r\n        }*/\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.farmer-devices {\r\n  .footer-buttons {\r\n    position: absolute;\r\n    right: 16px;\r\n    bottom: 16px;\r\n    z-index: 20;\r\n    pointer-events: none;\r\n\r\n    /*@media (max-width: $layout-breakpoint-sm) {\r\n      right: 87px;\r\n    }*/\r\n  }\r\n}\r\n\r\n.device-field {\r\n  background: #E8E8E8;\r\n  border: none;\r\n  margin: 15px 0;\r\n  height: 45px;\r\n  input {\r\n    width: 100%; height: 100%;\r\n    padding: 5px 10px;\r\n    font-size: 16px;\r\n    background: none;\r\n    border: none;\r\n    display: flex;\r\n  }\r\n}\r\n.select-farmer-device-dialog {\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex-grow: 1;\r\n  align-items: center;\r\n\r\n  .device-card {\r\n    _border: 1px solid lightgray;\r\n    padding: 10px;\r\n    margin: 10px;\r\n    background: white; // #f3f3f3;\r\n    border-radius: 5px;\r\n    flex-grow: 1;\r\n\r\n    \r\n    .device-header {\r\n      margin: 10px;\r\n    }\r\n    .device-title {\r\n      font-size: 22px;\r\n      justify-self: center;\r\n      display: flex;\r\n      flex-direction: column;\r\n      _flex-grow: 1;\r\n      align-content: center;\r\n      text-align: center;\r\n      color: #424242;\r\n    }\r\n    .device-content {\r\n      margin-top: 10px;\r\n      border-top: 1px solid lightgray;\r\n    }\r\n    .img-container {\r\n      width: 96px;\r\n      height: 96px;\r\n      \r\n      .device-pic {\r\n        max-height: 90px;\r\n      }\r\n    }\r\n  }\r\n\r\n  margin-top: 20px;\r\n  .device-type-card {\r\n    _border-radius: 8px;\r\n    max-height: 96px;\r\n    /* color: white; */\r\n    margin: 10px 20px;\r\n    \r\n    _background: white;\r\n    _box-shadow: 0 2px 4px -1px rgba(0,0,0,0.2), 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12);\r\n\r\n    .select-item-content {\r\n      margin: 25px;\r\n      .select-item-title {\r\n        margin: 5px 0;\r\n      }\r\n      .select-item-description {\r\n        font-size: 12px;\r\n        font-family: Roboto;\r\n        _margin: 5px 0;\r\n      }\r\n    }\r\n\r\n    .img-container {\r\n      width: 96px;\r\n      height: 96px;\r\n      _overflow: hidden;\r\n      _background-color: #fff;\r\n      _border-radius: 50%;\r\n\r\n      .device-pic {\r\n        &.silo {\r\n          height: 70px !important;\r\n        }\r\n        margin-right: 25px;\r\n        height: 96px;\r\n        padding: 10px;\r\n        \r\n        _max-height: 100%;\r\n        _width: 84%;\r\n      }\r\n    }\r\n\r\n    span {\r\n      margin-top: 8px;\r\n      font-size: 16px;\r\n      white-space: pre-wrap;\r\n\r\n      /*@media (max-width: 450px) {\r\n        margin-bottom: 0;\r\n        font-size: 13px;\r\n      }*/\r\n    }\r\n  }\r\n\r\n  .fade {\r\n    &.ng-enter {\r\n      opacity: 0;\r\n      transition: .5s linear all;\r\n    }\r\n\r\n    &.ng-enter.ng-enter-active {\r\n      opacity: 1;\r\n    }\r\n  }\r\n\r\n  .add-form-actions {\r\n    border-top-color: transparent;\r\n  }\r\n}\r\n\r\n.farmer-vertical-toolbar {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  z-index: 100;\r\n  width: 40px;\r\n  overflow-y: auto;\r\n\r\n  .ag-toolbar-button {\r\n    button.md-icon-button {\r\n      margin: 0;\r\n      border-radius: 0;\r\n    }\r\n\r\n    &.ag-selected {\r\n      border-left: #303c42 solid 4px;\r\n\r\n      button.md-icon-button {\r\n        margin-left: -4px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\nmd-toolbar:not(.md-menu-toolbar) {\r\n  &.farmer-vertical-toolbar {\r\n    background-color: #fff;\r\n\r\n    md-icon {\r\n      color: #303c42;\r\n      fill: #303c42;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
